import { type GetServerSideProps } from 'next';

import { getCategoryData } from '../../modules';
import { user } from '../../modules/user';

import { withEnhancedPageHandler } from '../../middlewares/withEnhancedPageHandler';

import { applyCorrelationIdHeader } from '../../utils/server/applyCorrelationIdHeader';

import { CategoryTemplateAbTest } from '../../templates/Category/_CategoryTemplateAbTest';
import { CategoryDialogsProvider } from '../../context/CategoryDialogsContext/CategoryDialogsContext';
import { getSlugLocalData } from '../../modules/category/shared/local';

import aliasData from '../../locales/pt-BR/category/alias.json';

const Category = (props) => (
  <CategoryDialogsProvider>
    <CategoryTemplateAbTest {...props} />;
  </CategoryDialogsProvider>
);

const getServerSidePropsHandler: GetServerSideProps = async ({
  params,
  req,
  query,
  locale,
  res,
}) => {
  const slug = (params.slug as string[]).join('/');

  const customHeaders = applyCorrelationIdHeader(req.headers);

  res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  );

  const categorySlug = slug;
  const { localData } = getSlugLocalData(slug);
  const { slugWithoutLocal } = localData;
  const rootCategory = aliasData[slugWithoutLocal];

  if (rootCategory) {
    return {
      redirect: {
        destination: `/${categorySlug.replace(slugWithoutLocal, rootCategory)}`,
        permanent: true,
      },
    };
  }

  const { userData: userResponse } = user.getData(req);
  const { notificationCount } = await user.getNotifications(req);

  const userData = userResponse
    ? {
        ...userResponse,
        isAuthenticated: true,
        notificationCount,
      }
    : {
        avatar: null,
        name: null,
        phone: null,
        isAuthenticated: false,
        notificationCount,
      };

  const props = await getCategoryData({
    slug,
    query,
    locale,
    customHeaders,
  });

  return {
    props: {
      ...props,
      userData,
    },
  };
};

export const getServerSideProps = withEnhancedPageHandler(
  getServerSidePropsHandler
);

export default Category;
